import { useEditor } from '@craftjs/core';
import { createElement } from 'react';
import { InspectorErrorFallback } from '../ErrorBoundary/ErrorFallback';
import * as Sentry from '@sentry/react';

interface InspectorProps {
  loading?: boolean;
}

const Inspector = ({ loading }: InspectorProps) => {
  const { selected } = useEditor((state) => {
    let [currentNodeId] = state.events.selected;
    if (!currentNodeId) {
      currentNodeId = 'ROOT';
    }
    let selected;
    if (currentNodeId && state.nodes[currentNodeId] && state.nodes[currentNodeId].data) {
      selected = {
        id: currentNodeId,
        name: state.nodes[currentNodeId].data.name,
        toolbar: state.nodes[currentNodeId].related && state.nodes[currentNodeId].related.toolbar,
      };
    }

    return {
      selected,
    };
  });

  return (
    <div className="w-[240px]" data-craft-history>
      <Sentry.ErrorBoundary
        key={selected?.id}
        fallback={
          <InspectorErrorFallback title="Error loading inspector" inspector={selected?.name} />
        }
        showDialog={false}
      >
        {selected?.toolbar &&
          createElement(selected.toolbar, {
            className: 'w-[240px]',
            text: selected.name,
            loading,
          })}
      </Sentry.ErrorBoundary>
    </div>
  );
};

export default Inspector;
